export default {
  // Page titles and headers
  pageTitle: 'Oj så många områden du sagt att du är nöjd med.',
  subtitle: 'Välj de TRE faktorer som du är ALLRA MEST NÖJD MED och reflektera en stund över vad det betyder för dig i ditt liv',
  goalsTitle: 'Mina mål',
  goalsSubtitle: 'Sätt dina personliga mål',
  improveTitle: 'Områden att förbättra',
  improveSubtitle: 'Välj områden du vill arbeta med',
  satisfiedWith: 'Detta är jag nöjd med',
  wantToImprove: 'Detta vill jag förbättra',
  howDoYouFeel: 'Hur känner du för detta?',
  
  // Button labels
  saveGoals: 'Spara mål',
  continueToPlan: 'Fortsätt till plan',
  backToGoals: 'Tillbaka till mål',
  selectGoals: 'Välj mål',
  clearSelection: 'Rensa val',
  
  // Loading states
  loadingValues: 'Laddar värden...',
  loadingGoals: 'Laddar mål...',
  savingChoices: 'Sparar dina val...',
  loadingOptions: 'Laddar dina alternativ...',
  savingGoals: 'Sparar mål...',
  
  // Selection messages
  maxSelections: 'Maximalt {count} val',
  selectedCount: '{count} valda',
  selectMore: 'Välj {count} till',
  tooManySelected: 'För många valda. Avmarkera några.',
  selectedAreas: 'Välj {count}-{max} områden att förbättra!',
  goalsSelected: 'Välj {count}-{max} områden att förbättra!',
  areasSelected: 'Du har valt {count} av {max} möjliga områden',
  
  // Instructions
  instructions: 'Instruktioner',
  selectInstructions: 'Klicka på områdena du vill välja',
  deselectInstructions: 'Klicka igen för att avmarkera',
  maxSelectionReached: 'Maximalt antal val uppnått',
  improveInstructions: 'Här är listan på vad du sagt att du vill förbättra.',
  improveInstructionsDetail: 'Gå runt i cirkeln och klicka på det område som är ALLRA viktigast för dig att FÖRBÄTTRA.',
  decideYourGoal: 'Nu ska du bestämma ditt MÅL',
  yourGoal: 'Ditt mål',
  selectedImproveArea: 'Du har valt att förbättra dig inom området {area} från värde {from} till {to}.',
  categoryValueInstruction: 'Klicka på HUR MYCKET du vill förbättra ditt värde. Det är det du ska uppnå.',
  chooseImproveValueHint: 'Välj nu vad som är VIKTIGAST ATT FÖRBÄTTRA för att du ska nå ditt MÅL.',
  singleChangeOnlyHint: 'Välj nu 1-3 saker som du tror måste förändras för att du ska nå ditt MÅL.',
  chooseImproveAmountHint: 'Klicka på HUR MYCKET du vill förbättra vart och ett av dem.',
  chooseSingleRiskImproveHint: 'Välj nu endast ETT område som du har riskvärde på (1 eller 2) som du tror måste förbättras för att du ska nå detta mål. Klicka på den siffra du vill uppnå.',
  chooseOneImproveArea: 'Välj ut ETT område nedan och klicka på det värde du vill uppnå för att vara säker på att nå målet för {area}.',
  workAreaTitle: 'MITT ARBETE',
  combinedGoalRange: 'Mål 1 - {total}',
  combinedActionIntro: 'Du har valt att öka dina värden enligt följande: {goals}',
  
  // Categories
  physical: 'Fysiskt',
  mental: 'Mentalt',
  social: 'Socialt',
  work: 'Arbete',
  lifestyle: 'Livsstil',
  health: 'Hälsa',
  fitness: 'Fitness',
  nutrition: 'Näring',
  sleep: 'Sömn',
  stress: 'Stress',
  relationships: 'Relationer',
  workLifeBalance: 'Arbetslivsbalans',
  
  // Status messages
  goalsSaved: 'Mål sparade framgångsrikt',
  goalsUpdated: 'Mål uppdaterade framgångsrikt',
  noGoalsSelected: 'Inga mål valda',
  pleaseSelectGoals: 'Välj minst ett faktor',
  selectAtLeastOne: 'Välj minst ett MÅL att förbättra',
  selectAtLeastOneArea: 'Välj minst ett område',
  subtitleRange: 'Välj mellan {min} och {max} områden att förbättra',
  subtitleRangeAreas: 'Välj de TRE områden som du är ALLRA MEST NÖJD MED och reflektera en stund över vad det betyder för dig i ditt liv',
  noImprovementsSelected: 'Du har inte valt något att förbättra.',
  
  // Error messages
  errorLoadingGoals: 'Fel vid laddning av mål',
  errorSavingGoals: 'Fel vid sparande av mål',
  tryAgainLater: 'Försök igen senare',
  
  // Plan page translations
  howToReachGoals: 'Äntligen sista steget',
  yourImportantGoals: 'Nu ska du bara bestämma dig för HUR du ska nå dina MÅL. Lugn, jag vägleder dig hela vägen. Vi tar ett MÅL i taget! Dina MÅL är alltså att förbättra:',
  goToEvaluation: 'Gå till utvärdering',
  fillAllGoals: 'Fyll i alla dina mål för att fortsätta',
  valueIncrease: 'Jag har valt att öka mitt värde från {from} till {to}.',
  relatedToGoal: 'Välj ut det som  är viktigast och klicka på hur mycket du tänker förbättra dig!',
  writeBriefly: 'Skriv jättekort VAD du ska göra för att nå ditt mål.',
  goalAchievedBy: 'Ska klaras senast',
  date: 'Datum',
  dateRequired: 'Du måste fylla i ett datum.',
  save: 'Spara',
  
  // Help text
  helpText: 'Välj områden som är viktigast för dig',
  tipText: 'Du kan ändra ditt val när som helst',
  moreInfo: 'Mer information om mål',
  
  // Dialog messages
  limitReached: 'Gräns',
  limitMessage: 'Du kan bara välja ett förbättringsområde åt gången. Ta bort det befintliga valet för att välja ett annat.',
  incompleteSelection: 'Ofullständigt val',
  incompleteMessage: 'Du måste välja minst 1 MÅL att förbättra för att fortsätta.',
  selectedGoals: 'Dina valda mål',
  selectedGoalsSubheader: 'Du har valt dessa MÅL att förbättra:',
  change: 'Ändra',
  continue: 'Fortsätt',
  
  // Progress
  step1: 'Steg 1: Välj nöjda områden',
  step2: 'Steg 2: Sätt förbättringsmål',
  step3: 'Steg 3: Skapa handlingsplan',
  
  // Confirmation
  confirmSelection: 'Bekräfta val',
  confirmMessage: 'Är du säker på att du vill spara dessa mål?',
  yes: 'Ja',
  no: 'Nej',
  // Plan results page translations
  summary: 'Sammanfattning',
  planComplete: 'Din livsstilsplan är nu klar!',
  yourGoals: 'Dina mål',
  goalsSummary: 'Här är en sammanfattning av din Livsstilsplan, dina samband och din egen beskrivning:',
  willImprove: 'Jag ska förbättra',
  goalAchievedByDate: 'Målet ska uppnås {date}.',
  willDoFollowing: 'Min beskrivning:',
  finallyComplete: 'Äntligen klar! Nästa steg är att starta rätt AI-plan för dina mål.',
  completeLifestylePlan: 'Slutför och fortsätt till AI-coachen',
  loadingPlan: 'Hämtar din plan...',
  
  // Feedback modal translations
  closingQuestions: 'Avslutande frågor',
  just4Questions: 'Nu bara 3 avslutande frågor om vad du tycker om Bwell-arbetet.',
  questionsAnswered: '{answered} / {total} frågor besvarade',
  helpUsImprove: 'Klicka på det värde 1-5 som passar bäst in på din upplevelse av Bwell (OBS 5 = högsta betyg)',
  noQuestionsAvailable: 'Inga frågor tillgängliga just nu.',
  answerRegistered: 'Svar registrerat',
  pleaseAnswerAll: 'Vänligen besvara alla frågor för att fortsätta',
  sending: 'Skickar...',
  sendAnswers: 'Skicka svar',
  failedToSend: 'Det gick inte att skicka svaren. Försök igen.',
  thankYouForFeedback: 'Tack för din feedback!',
  feedbackHelpsImprove: 'Dina svar hjälper oss att förbättra Bwell.',
  failedToLoadQuestions: 'Kunde inte ladda feedbackfrågor',

  // Goals page titles and messages
  myGoals: 'Mina mål',
  thanksForAnswering: 'Tack för att du har svarat på frågorna. Du kan nu gå vidare.',
  myLifestylePlan: 'Min livsstilsplan',
  loadingLifestylePlan: 'Laddar din livsstilsplan...',
  creatingImage: 'Skapar bild...',
  saveAsImageA4: 'Spara som bild (A4)',
  sendingEmail: 'Skickar...',
  emailPlanResult: 'Skicka resultatet till min e-post',
  startMessage: 'Då vet du utgångsläget. Nu ska du sätta upp några MÅL framåt. VAD VILL DU UPPNÅ?',
  planPreludeMessage: 'Inte långt kvar nu. Nu är det dags att bestämma VAD du ska göra för att nå dina MÅL.',

  // Goals reflection page
  reflectionMessage: 'Va bra! Stanna upp lite nu och fundera på hur det påverkar ditt liv.',

  // Plan action page translations
  lifestylePlan: 'Livsstilsplan',
  goal: 'Mål',
  goalNumber: 'Mål {current} - {total}',
  actionPlanTitle: '{goal}',
  valueIncreaseFull: 'Jag har valt att öka mitt värde från {from} till {to}.',
  valueIncreaseFactorFull: 'Jag har valt att förbättra {factor} från värde {from} till {to}.',
  selectedFactor: 'Vald förbättring',
  actionGoalTitle: 'MÅL: {category}',
  toBeCompletedBy: 'Ska klaras senast',
  riskAreasDescription: 'Här är sådant som påverkar dina möjligheter att klara detta. Välj ut max 3 saker och klicka på HUR MYCKET du tänker förbättra varje.',
  loadingFactors: 'Laddar faktorer...',
  noImprovementAreas: 'Detta mål har inga sambandsfaktorer valda. Du kan gå direkt till att beskriva din situation.',
  selectedAreasForGoal: 'Valda sambandsfaktorer för: {goal}',
  selectedConnectionsForCombinedGoal: 'Du har valt ut det som du tror krävs för att nå ditt MÅL: {goal}. Bestäm nu NÄR du ska ha uppnått MÅLET.',
  myActionPlanFor: 'Mitt läge idag när jag ska nå MÅLET {category}',
  actionPlanInstructions: 'Beskriv kort med egna ord hur du upplever de negativa effekterna inom {category}. Viktig info för att din BwellAI-Coach ska kunna ge dig stöd.',
  writePlanPlaceholder: 'Ex: Jag får ofta huvudvärk på kvällen när jag sovit dåligt och suttit länge vid skärm...',
  updateLifestylePlan: 'Vi ses igen när det är dags att uppdatera din Livsstilsplan.',
  value: 'Värde',
  
  // Plan modal translations
  oldPlanWarning: 'Detta är en gammal livsstilsplan! Innehållet nedan kan därför se lite konstigt ut.',
  myWork: 'Mitt arbete',
  myLifestyle: 'Min livsstil',
}; 
